import React, { useContext } from 'react';
import Button from '@mui/material/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import FacebookSharpIcon from '@mui/icons-material/FacebookSharp';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

import CallRoundedIcon from '@mui/icons-material/CallRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import ButtonGroup from '@mui/material/ButtonGroup';
import SideButton from './sideButton';
import { SchoolContex } from '../../Helper/Contex';

function OffcanvasExample(props) {

  const { schools } = useContext(SchoolContex)

  const navigation = useNavigate();

  // console.log(schools ,'schools');

  return (
    <>
      <SideButton />

      <div>
        <div className="row m-0 p-0 bg-dark">
          <div className="col-md-12">
            <div className='d-flex justify-content-between mx-md-2 my-1'>

              <div className='d-none d-md-block d-sm-block '>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton aria-label="delete" size="small" sx={{ color: 'white' }}>
                    <a href="tel:+918811099994">
                      <CallRoundedIcon fontSize="inherit" titleAccess='Call Us' />
                    </a>
                  </IconButton>
                  <IconButton aria-label="delete" size="small">
                    <EmailRoundedIcon fontSize="inherit" sx={{ color: 'white' }} titleAccess='Mail Us' />
                  </IconButton>
                </Stack>
              </div>
              <div className='w-100 nv-stop'>

                <ButtonGroup className='w-100' size="small" aria-label="small button group">
                  <div className='btn-group w-100 justify-content-center'>
                    <div>
                      <Button variant="contained" size="small" color='error' onClick={() => navigation('/register')}>Apply Online</Button>
                    </div>
                    <div>
                      <Button variant="contained" size="small" color='warning' className='mx-md-2' >Results</Button>
                    </div>
                    <div>
                      <Button variant="contained" size="small" color='primary' onClick={() => navigation('/Ragging')}>Anti Ragging</Button>
                    </div>
                  </div>

                  {/* <Button variant="contained" size="small" color='success'>Apply Online</Button> */}
                </ButtonGroup>
              </div>


              <div className='d-none d-md-block d-sm-block'>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton aria-label="delete" size="small">
                    <a href='https://www.facebook.com/PEWSGHY/' target='_blank'>
                      <FacebookSharpIcon fontSize="inherit" sx={{ color: 'white' }} titleAccess='Facebook' />
                    </a>
                  </IconButton>
                  <IconButton aria-label="delete" size="small">
                    <a href='https://www.instagram.com/pewsghy/?igshid=YmMyMTA2M2Y%3D' target='_blank'>
                      <InstagramIcon fontSize="inherit" sx={{ color: 'white' }} titleAccess='Instagram' />
                    </a>
                  </IconButton>
                  <IconButton aria-label="delete" size="small" >
                    <a href='https://www.youtube.com/channel/UCpOMWresYXFVxmehptHM98g' target='_blank'>
                      <YouTubeIcon fontSize="inherit" sx={{ color: 'white' }} titleAccess='Youtube' />
                    </a>
                  </IconButton>
                </Stack>
              </div>

            </div>
          </div>
        </div>
      </div>


      {['md'].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className=" p-0 line">
          <Container fluid>
            <Navbar.Brand href="/">
              <img src='/assets/logo.webp' alt='pews logo' height={50}></img>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  PEWS
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Link className='nav-link' to="/">HOME</Link>
                  <Link className='nav-link' to="/about">ABOUT</Link>
                  <Link className='nav-link' to="/register">ADMISSION</Link>
                  <NavDropdown
                    title="COLLEGES"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    {schools && schools.map((sch) =>
                    (
                      <Link className='dropdown-item' to={`/school/${sch.slug}/${sch.id}`}>
                        {sch.schoolName}
                      </Link>
                    ))}

                  </NavDropdown>

                  {/* <Link className='nav-link' to="/">Student Corner</Link> */}
                  {/* <Link className='nav-link' to="/">Jobs & Vacancies</Link> */}
                  {/* <Link className='nav-link' to="/blogs">BLOGS</Link> */}
                  <NavDropdown
                    title="FACULTIES"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    {schools && schools.map((sch) =>
                    (
                      <Link className='dropdown-item' to={`/faculty/${sch.slug}/${sch.id}`}>
                        {sch.schoolName}
                      </Link>
                    ))}

                  </NavDropdown>
                  <Link className='nav-link' to="/alumni">ALUMNI</Link>
                  <Link className='nav-link' to="/placement">PLACEMENT</Link>
                  <Link className='nav-link' to="/hiring">CAREER</Link>
                  <NavDropdown
                    title="STUDENT CORNER"
                  >
                    <Link to="/blogs" className='dropdown-item'>Blogs</Link>
                    <Link to="/StudentLogin" className='dropdown-item'>Registration</Link>
                  </NavDropdown>
                  <Link className='nav-link' to="/contact">CONTACT US</Link>


                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default OffcanvasExample;